"use strict";
import { NativeCurrency, Token } from "@uniswap/sdk-core";
import { MULTICALL3_ADDRESS } from "constants/bscContracts";
import { UniverseChainId } from "features/chains/types";
const PLACEHOLDER_ADDRESS = "0x0000000000000000000000000000000000000000";
export class WhitelistedToken extends Token {
  verified;
  whitelisted;
  feeOnTransfer;
  constructor(chainId, address, decimals, symbol, name, whitelisted = false, feeOnTransfer = false, verified = true) {
    super(chainId, address, decimals, symbol, name);
    this.verified = verified;
    this.whitelisted = whitelisted;
    this.feeOnTransfer = feeOnTransfer;
  }
}
export const WBNB_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
  // BSC testnet WBNB (canonical)
  18,
  "WBNB",
  "Wrapped BNB",
  false
);
export const TOPAZ_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0xdf002282C1474C9592780618Adda7EaA99998Abd",
  18,
  "TOPAZ",
  "Topaz Token",
  true
);
export const USDC_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0x878566c3C680039CE7655eA3bB1cA5CA7507aa32",
  18,
  "USDC",
  "USD Coin",
  true
);
export const USDT_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0x764bf419ed27979713f197cbe1416a1695f639fa",
  18,
  "USDT",
  "Tether USD",
  true
);
export const ETH_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0xaAf5f2Bb24f04ca6139c4EB153d650c3278276F3",
  18,
  "ETH",
  "Ethereum (Binance-Peg)",
  true
);
export const CAKE_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0x3221ac6A80028eFC71d501D853e3Cc1829e31B08",
  18,
  "CAKE",
  "PancakeSwap Token",
  true
);
export const BTCB_BSC_TESTNET = new WhitelistedToken(
  UniverseChainId.Sepolia,
  "0xF9750A1d19b70FCA58FAB8410EC57c43E9Fe035a",
  18,
  "BTCB",
  "Bitcoin BEP20",
  true
);
export const WBNB_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  // BSC mainnet WBNB (canonical)
  18,
  "WBNB",
  "Wrapped BNB",
  true
);
export const TOPAZ_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xdf002282C1474C9592780618Adda7EaA99998Abd",
  18,
  "TOPAZ",
  "Topaz Token",
  true
);
export const USDC_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
  18,
  "USDC",
  "USD Coin",
  true
);
export const USDT_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x55d398326f99059fF775485246999027B3197955",
  18,
  "USDT",
  "Tether USD",
  true
);
export const USD1_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d",
  18,
  "USD1",
  "World Liberty Financial USD",
  true
);
export const ETH_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
  18,
  "ETH",
  "Ethereum (Binance-Peg)",
  true
);
export const BTCB_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c",
  18,
  "BTCB",
  "Bitcoin BEP20",
  true
);
export const SOL_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x570A5D26f7765Ecb712C0924E4De545B89fD43dF",
  18,
  "SOL",
  "Solana (Binance-Peg)",
  true
);
export const CAKE_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82",
  18,
  "CAKE",
  "PancakeSwap Token",
  true
);
export const FDUSD_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409",
  18,
  "FDUSD",
  "First Digital USD",
  true
);
export const DOGE_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xbA2aE424d960c26247Dd6c32edC70B295c744C43",
  8,
  "DOGE",
  "Dogecoin",
  true
);
export const XRP_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE",
  18,
  "XRP",
  "XRP Token",
  true
);
export const BOOK_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xC9Ad421f96579AcE066eC188a7Bba472fB83017F",
  18,
  "BOOK",
  "Book of Binance",
  true
);
export const BLUE_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xa90298e5B1203A2DD0006A75EABE158989C406Fb",
  9,
  "BLUE",
  "Blue Protocol",
  true
);
export const GBLUE_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x158ff17474D7ACd29C13f26C5D27B293Ef0A1410",
  18,
  "GBLUE",
  "Governance Blue",
  true
);
export const CLIPX_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xc269d59a0D608EA0bd672F2F4616C372d8554444",
  18,
  "ClipX",
  "ClipX",
  true
);
export const BUD_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xc28957E946AC244612BcB205C899844Cbbcb093D",
  18,
  "BUD",
  "BOOKUSD",
  true
);
export const BUSS_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xfC35Bf79270bCad22Ce7dd5651Aa2435fce9b7C5",
  18,
  "BUSS",
  "BOOKUSD SHARE",
  true
);
export const BULLA_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x595E21b20E78674F8a64C1566A20b2b316Bc3511",
  18,
  "BULLA",
  "BULLA",
  true
);
export const SIREN_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x997A58129890bBdA032231A52eD1ddC845fc18e1",
  18,
  "SIREN",
  "SIREN",
  true
);
export const PUP_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x73b84F7E3901F39FC29F3704a03126D317Ab4444",
  18,
  "PUP",
  "PUP",
  false
);
export const FOUR_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x0A43fC31a73013089DF59194872Ecae4cAe14444",
  18,
  "4",
  "4",
  false
);
export const PALU_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x02e75d28A8AA2a0033b8cf866fCf0bB0E1eE4444",
  18,
  "PALU",
  "Palu",
  false
);
export const BIBI_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x9212cF1f9f4A9c69Bb010146Ba5b0725169D4444",
  18,
  "bibi",
  "Binance bibi",
  true
);
export const BROCCOLI_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x12B4356C65340Fb02cdff01293F95FEBb1512F3b",
  18,
  "Broccoli",
  "Broccoli",
  true
);
export const CAPTAIN_BNB_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x47A1EB0b825b73e6A14807BEaECAFef199d5477c",
  18,
  "CaptainBNB",
  "CaptainBNB",
  true
);
export const NIAN_NIAN_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x9C27c4072738CF4b7B0B7071af0ad5666BdDC096",
  18,
  "NianNian",
  "NianNian",
  true
);
export const RISE_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x64FDD8a6c19d66a5b917a015868c5611261C4444",
  18,
  "$RISE",
  "1st Moon Mascot",
  true
);
export const INTCLAW_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xF3c571AA528C03d64fA825Af7bc544FD1953FFff",
  18,
  "intCLAW",
  "pCLAW Coin",
  false,
  true
);
export const TRUSTY_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x65aea108c21439693468FCD542D81C29E8df4444",
  18,
  "Trusty",
  "TWT Mascot",
  true
);
export const EARN_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x2aC895fEba458B42884DCbCB47D57e44c3a303c8",
  18,
  "Earn",
  "HOLD",
  true
);
export const XPBNB_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xcC935bE86C9A12837cC2c27b43FA2F8aa69AFfff",
  18,
  "xPBNB",
  "PredictBNB Agent",
  false,
  true
);
export const BUILD4_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x1d547f9d0890EE5AbfB49d7d53cA19Df85Da4444",
  18,
  "B4",
  "BUILD4",
  true
);
export const BEISHOUFUSHU_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x5f6fD60AD6Cd8751B4c521bC00FA02ABfECA4444",
  18,
  "\u80CC\u624B\u8D1F\u9F20",
  "\u5168\u7F51\u7206\u706B\u8868\u60C5\u5305"
);
export const TWT_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x4B0F1812e5Df2A09796481Ff14017e6005508003",
  18,
  "TWT",
  "Trust Wallet",
  true
);
export const UB_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x40b8129B786D766267A7a118cF8C07E31CDB6Fde",
  18,
  "UB",
  "Unibase",
  true
);
export const B_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x6bdcCe4A559076e37755a78Ce0c06214E59e4444",
  18,
  "B",
  "B",
  true
);
export const SKYAI_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x92aa03137385F18539301349dcfC9EbC923fFb10",
  18,
  "SKYAI",
  "SKYAI",
  true
);
export const GENIUS_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x1F12B85aAC097E43Aa1555b2881E98a51090e9A6",
  18,
  "GENIUS",
  "Genius",
  true
);
export const BIANRENSHENG_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x924fa68a0FC644485b8df8AbfA0A41C2e7744444",
  18,
  "\u5E01\u5B89\u4EBA\u751F",
  "\u5E01\u5B89\u4EBA\u751F",
  true
);
export const STONKS_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xA1c9ae1Ac8b55edCd580930263D180c647044444",
  18,
  "STNK",
  "Stonks",
  true
);
export const GRASS_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xf43AC1E44bcB375D318d4Fa265eFf191a229c8DB",
  18,
  "GRASS",
  "Touch Grass",
  true
);
export const ZEC_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x1Ba42e5193dfA8B03D15dd1B86a3113bbBEF8Eeb",
  18,
  "ZEC",
  "Zcash Token",
  true
);
export const SPCXON_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xd0a58BC9D88D3FF48C0294Cb7e45937d0E41A928",
  18,
  "SPCXon",
  "SpaceX (Ondo Tokenized)",
  true
);
export const VELVET_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x8b194370825E37b33373e74A41009161808C1488",
  18,
  "VELVET",
  "Velvet",
  true
);
export const KORICO_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0xbb87Dc5daAC59D6e11ea2461cA69543f4B844444",
  18,
  "Korico",
  "Korico",
  true
);
export const ASTER_BSC_MAINNET = new WhitelistedToken(
  UniverseChainId.Mainnet,
  "0x000Ae314E2A2172a039B26378814C252734f556A",
  18,
  "ASTER",
  "Aster",
  true
);
export const USDC = USDC_BSC_MAINNET;
export const USDT = USDT_BSC_MAINNET;
export const TOPAZ = TOPAZ_BSC_MAINNET;
export const TOPAZ_TOKENS = {
  [UniverseChainId.Mainnet]: TOPAZ_BSC_MAINNET,
  [UniverseChainId.Sepolia]: TOPAZ_BSC_TESTNET
};
export const WRAPPED_NATIVE_CURRENCY = {
  [UniverseChainId.Mainnet]: WBNB_BSC_MAINNET,
  [UniverseChainId.Sepolia]: WBNB_BSC_TESTNET
};
export function getToken(chainId) {
  switch (chainId) {
    case UniverseChainId.Mainnet:
      return {
        usdc: USDC_BSC_MAINNET,
        usdt: USDT_BSC_MAINNET,
        weth: WBNB_BSC_MAINNET,
        topaz: TOPAZ_BSC_MAINNET
      };
    case UniverseChainId.Sepolia:
      return {
        usdc: USDC_BSC_TESTNET,
        usdt: USDT_BSC_TESTNET,
        weth: WBNB_BSC_TESTNET,
        topaz: TOPAZ_BSC_TESTNET
      };
    default:
      throw new Error(`Unsupported chain ID: ${chainId}`);
  }
}
export function getStablecoins(chainId) {
  switch (chainId) {
    case UniverseChainId.Mainnet:
      return [USDC_BSC_MAINNET, USDT_BSC_MAINNET, USD1_BSC_MAINNET, FDUSD_BSC_MAINNET];
    case UniverseChainId.Sepolia:
      return [USDC_BSC_TESTNET, USDT_BSC_TESTNET];
    default:
      return [];
  }
}
export function getDexTokenList(chainId) {
  if (chainId === UniverseChainId.Mainnet) {
    return [
      WBNB_BSC_MAINNET,
      TOPAZ_BSC_MAINNET,
      USDC_BSC_MAINNET,
      USDT_BSC_MAINNET,
      USD1_BSC_MAINNET,
      ETH_BSC_MAINNET,
      BTCB_BSC_MAINNET,
      SOL_BSC_MAINNET,
      CAKE_BSC_MAINNET,
      FDUSD_BSC_MAINNET,
      DOGE_BSC_MAINNET,
      XRP_BSC_MAINNET,
      BOOK_BSC_MAINNET,
      BLUE_BSC_MAINNET,
      GBLUE_BSC_MAINNET,
      CLIPX_BSC_MAINNET,
      BUD_BSC_MAINNET,
      BUSS_BSC_MAINNET,
      BULLA_BSC_MAINNET,
      SIREN_BSC_MAINNET,
      PUP_BSC_MAINNET,
      FOUR_BSC_MAINNET,
      PALU_BSC_MAINNET,
      BIBI_BSC_MAINNET,
      BROCCOLI_BSC_MAINNET,
      CAPTAIN_BNB_BSC_MAINNET,
      NIAN_NIAN_BSC_MAINNET,
      RISE_BSC_MAINNET,
      INTCLAW_BSC_MAINNET,
      TRUSTY_BSC_MAINNET,
      EARN_BSC_MAINNET,
      XPBNB_BSC_MAINNET,
      BUILD4_BSC_MAINNET,
      BEISHOUFUSHU_BSC_MAINNET,
      TWT_BSC_MAINNET,
      UB_BSC_MAINNET,
      B_BSC_MAINNET,
      SKYAI_BSC_MAINNET,
      GENIUS_BSC_MAINNET,
      BIANRENSHENG_BSC_MAINNET,
      STONKS_BSC_MAINNET,
      GRASS_BSC_MAINNET,
      ZEC_BSC_MAINNET,
      SPCXON_BSC_MAINNET,
      VELVET_BSC_MAINNET,
      KORICO_BSC_MAINNET,
      ASTER_BSC_MAINNET
    ];
  }
  return [
    WBNB_BSC_TESTNET,
    TOPAZ_BSC_TESTNET,
    USDC_BSC_TESTNET,
    USDT_BSC_TESTNET,
    ETH_BSC_TESTNET,
    BTCB_BSC_TESTNET,
    CAKE_BSC_TESTNET
  ];
}
export function getCommonBaseTokenList(chainId) {
  if (chainId === UniverseChainId.Mainnet) {
    return [
      WBNB_BSC_MAINNET,
      TOPAZ_BSC_MAINNET,
      USDT_BSC_MAINNET,
      USDC_BSC_MAINNET,
      BTCB_BSC_MAINNET,
      ETH_BSC_MAINNET
    ];
  }
  return [
    WBNB_BSC_TESTNET,
    TOPAZ_BSC_TESTNET,
    USDT_BSC_TESTNET,
    USDC_BSC_TESTNET,
    BTCB_BSC_TESTNET,
    ETH_BSC_TESTNET
  ];
}
export function isTokenWhitelistedForIncentives(token) {
  if (token.isNative) {
    const wrappedToken = WRAPPED_NATIVE_CURRENCY[token.chainId];
    if (wrappedToken instanceof WhitelistedToken) {
      return wrappedToken.whitelisted;
    }
    return false;
  }
  if (!("address" in token) || !token.address) {
    return false;
  }
  if (token instanceof WhitelistedToken) {
    return token.whitelisted;
  }
  const allWhitelisted = [
    ...getDexTokenList(UniverseChainId.Mainnet),
    ...getDexTokenList(UniverseChainId.Sepolia)
  ].filter((t) => t.whitelisted).map((t) => t.address.toLowerCase());
  return allWhitelisted.includes(token.address.toLowerCase());
}
export function getWhitelistedTokens(chainId) {
  return getDexTokenList(chainId).filter((token) => token.whitelisted);
}
export function isTokenVerified(token) {
  const verifiedAddresses = [
    ...getDexTokenList(UniverseChainId.Mainnet).map((t) => t.address.toLowerCase()),
    ...getDexTokenList(UniverseChainId.Sepolia).map((t) => t.address.toLowerCase())
  ];
  if (token.isNative) {
    const wrappedToken = WRAPPED_NATIVE_CURRENCY[token.chainId];
    if (wrappedToken instanceof WhitelistedToken) {
      return wrappedToken.verified;
    }
    return verifiedAddresses.includes(wrappedToken.address.toLowerCase());
  }
  if (!("address" in token) || !token.address) {
    return false;
  }
  if (token instanceof WhitelistedToken) {
    return token.verified;
  }
  return verifiedAddresses.includes(token.address.toLowerCase());
}
const FEE_ON_TRANSFER_TOKEN_ADDRESSES = [];
export function isTokenFeeOnTransfer(token) {
  if (!token || token.isNative) {
    return false;
  }
  if (!("address" in token) || !token.address) {
    return false;
  }
  if (token instanceof WhitelistedToken) {
    return token.feeOnTransfer;
  }
  return FEE_ON_TRANSFER_TOKEN_ADDRESSES.includes(token.address.toLowerCase());
}
export function getFeeOnTransferTokens(chainId) {
  return getDexTokenList(chainId).filter((token) => token.feeOnTransfer);
}
export function isCelo(_chainId) {
  return false;
}
export function isPolygon(_chainId) {
  return false;
}
export function isBsc(chainId) {
  return chainId === UniverseChainId.Mainnet || chainId === UniverseChainId.Sepolia;
}
export function isAvalanche(_chainId) {
  return false;
}
export class ExtendedEther extends NativeCurrency {
  get wrapped() {
    const chainId = this.chainId;
    return WRAPPED_NATIVE_CURRENCY[chainId];
  }
  constructor(chainId) {
    super(chainId, 18, "BNB", "BNB");
  }
  static _cachedExtendedEthers = {};
  static onChain(chainId) {
    return this._cachedExtendedEthers[chainId] ?? (this._cachedExtendedEthers[chainId] = new ExtendedEther(chainId));
  }
  equals(other) {
    return other.isNative && other.chainId === this.chainId;
  }
}
export function getNativeTokenDBAddress(_chain) {
  return void 0;
}
export function nativeOnChain(chainId) {
  return ExtendedEther.onChain(chainId);
}
export const UNIVERSAL_ROUTER_ADDRESS = (chainId) => {
  switch (chainId) {
    case UniverseChainId.Mainnet:
    case UniverseChainId.Sepolia:
      return PLACEHOLDER_ADDRESS;
    // TODO(topaz): fill after BSC deployment
    default:
      throw new Error(`Universal Router not deployed on chain ${chainId}`);
  }
};
export const UNI = {
  [UniverseChainId.Mainnet]: new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "UNI", "Uniswap"),
  [UniverseChainId.Sepolia]: new Token(UniverseChainId.Sepolia, PLACEHOLDER_ADDRESS, 18, "UNI", "Uniswap")
};
export const UNI_ADDRESSES = {
  [UniverseChainId.Mainnet]: UNI[UniverseChainId.Mainnet].address,
  [UniverseChainId.Sepolia]: UNI[UniverseChainId.Sepolia].address
};
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = {
  [UniverseChainId.Mainnet]: PLACEHOLDER_ADDRESS,
  [UniverseChainId.Sepolia]: PLACEHOLDER_ADDRESS
};
export const MULTICALL_ADDRESSES = {
  [UniverseChainId.Mainnet]: MULTICALL3_ADDRESS,
  [UniverseChainId.Sepolia]: MULTICALL3_ADDRESS
};
export const V3_MIGRATOR_ADDRESSES = {
  [UniverseChainId.Mainnet]: PLACEHOLDER_ADDRESS,
  [UniverseChainId.Sepolia]: PLACEHOLDER_ADDRESS
};
export const CHAIN_TO_ADDRESSES_MAP = {
  [UniverseChainId.Mainnet]: {
    multicallAddress: MULTICALL_ADDRESSES[UniverseChainId.Mainnet],
    v3CoreFactoryAddress: PLACEHOLDER_ADDRESS,
    v3MigratorAddress: V3_MIGRATOR_ADDRESSES[UniverseChainId.Mainnet],
    quoterAddress: PLACEHOLDER_ADDRESS
  },
  [UniverseChainId.Sepolia]: {
    multicallAddress: MULTICALL_ADDRESSES[UniverseChainId.Sepolia],
    v3CoreFactoryAddress: PLACEHOLDER_ADDRESS,
    v3MigratorAddress: V3_MIGRATOR_ADDRESSES[UniverseChainId.Sepolia],
    quoterAddress: PLACEHOLDER_ADDRESS
  }
};
export const WETH9 = {
  [UniverseChainId.Mainnet]: WBNB_BSC_MAINNET,
  [UniverseChainId.Sepolia]: WBNB_BSC_TESTNET
};
export const TOKEN_MAP = {
  USDC_BSC_MAINNET,
  USDT_BSC_MAINNET,
  USDC_BSC_TESTNET,
  USDT_BSC_TESTNET,
  WBNB_BSC_MAINNET,
  WBNB_BSC_TESTNET,
  TOPAZ_BSC_MAINNET,
  TOPAZ_BSC_TESTNET
};
export const USDC_MAINNET = USDC_BSC_MAINNET;
export const USDC_SEPOLIA = USDC_BSC_TESTNET;
export const USDT_MAINNET = USDT_BSC_MAINNET;
export const DAI_MAINNET = USDC_BSC_MAINNET;
export const WBTC = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 8, "WBTC", "Wrapped Bitcoin");
export const LDO = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "LDO", "Lido DAO Token");
export const NMR = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "NMR", "Numeraire");
export const MNW = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "MNW", "Morphware");
export const ARB = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "ARB", "Arbitrum");
export const OP = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "OP", "Optimism");
export const PORTAL_ETH_CELO = new Token(UniverseChainId.Mainnet, PLACEHOLDER_ADDRESS, 18, "ETH", "Portal ETH");
export const BTC_BSC = WBTC;
export const BUSD_BSC = USDC_BSC_MAINNET;
export const ETH_BSC = WBNB_BSC_MAINNET;
export const DAI_AVALANCHE = USDC_BSC_MAINNET;
export const USDT_AVALANCHE = USDT_BSC_MAINNET;
export const WETH_AVALANCHE = WBNB_BSC_MAINNET;
export const USDC_OPTIMISM = USDC_BSC_MAINNET;
export const USDT_OPTIMISM = USDT_BSC_MAINNET;
export const DAI_OPTIMISM = USDC_BSC_MAINNET;
export const USDC_BASE = USDC_BSC_MAINNET;
export const USDC_BNB = USDC_BSC_MAINNET;
export const USDT_BNB = USDT_BSC_MAINNET;
export const USDC_BSC = USDC_BSC_MAINNET;
export const USDT_BSC = USDT_BSC_MAINNET;
export const DAI_BSC = USDC_BSC_MAINNET;
export const DAI_POLYGON = USDC_BSC_MAINNET;
export const USDC_POLYGON = USDC_BSC_MAINNET;
export const USDT_POLYGON = USDT_BSC_MAINNET;
export const USDT_ARBITRUM_ONE = USDT_BSC_MAINNET;
export const USDC_ARBITRUM = USDC_BSC_MAINNET;
export const DAI_ARBITRUM_ONE = USDC_BSC_MAINNET;
export const USDC_AVALANCHE = USDC_BSC_MAINNET;
export const USDC_CELO = USDC_BSC_MAINNET;
export const CUSD_CELO = USDC_BSC_MAINNET;
export const USDC_ZKSYNC = USDC_BSC_MAINNET;
export const USDC_ZORA = USDC_BSC_MAINNET;
export const USDB_BLAST = USDC_BSC_MAINNET;
export const USDC_WORLD_CHAIN = USDC_BSC_MAINNET;
export const USDC_UNICHAIN = USDC_BSC_MAINNET;
export const USDC_UNICHAIN_SEPOLIA = USDC_BSC_TESTNET;
export const USDT_MONAD_TESTNET = USDT_BSC_TESTNET;
export const USDC_SONEIUM = USDC_BSC_MAINNET;
export function getBscTokenList(chainId) {
  return getDexTokenList(chainId);
}
